import { render, staticRenderFns } from "./Visit-list.vue?vue&type=template&id=3808f690&"
import script from "./Visit-list.vue?vue&type=script&lang=js&"
export * from "./Visit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports